//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('deviationTypeLangs', {
//        templateUrl: 'views/components/views/deviationTypeLangs/deviationTypeLangs.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'deviationTypeLangsService', function ($stateParams, stateService, translateService, modalService, deviationTypeLangsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let deviationTypeKeyno = $stateParams.deviationtype_keyno;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                inputListLanguages: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATE SERVICE

//            // #region LOAD PROCEDURE FUNCTION

//            async function loadLanguages() {
//                vm.model.inputListLanguages = (await deviationTypeLangsService.listDeviationTypeLanguages({ deviationtype_keyno: deviationTypeKeyno }));
//            }

//            // #endregion LOAD PROCEDURE FUNCTION

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                deviationTypeLangsService.saveObj({ records: vm.model.inputListLanguages }).then(function (response) {
//                    if (response[0].ws_result === '1') {
//                    	modalService.show({
//                    		type: 'success',
//                    		title: translations.error,
//                            message: response[0].ws_result_message,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-success',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                    stateService.back();
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.$onInit = function () {
//                translate();
//                loadLanguages();
//            };
//        }]
//    });
//})();
